import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {ImageWrapper} from 'shells/onboarding-modal/image-wrapper';

import type {ExternalServiceType} from 'nutshell-graphql-types';

import {MeetingImage} from '../meeting-image';

const width = 280;

export const getArt = (serviceType: ExternalServiceType) => ({
    background: colors.plumLt,
    image: () => (
        <ImageWrapper
            image={<MeetingImage width={width} serviceType={serviceType} />}
            width={width}
        />
    ),
});
